import getEnvValue from './getEnvValue';

const isBuildPhase = () => getEnvValue('NEXT_PUBLIC_IS_BUILD_PHASE') === 'true';

export default isBuildPhase;
